var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0952 0H61.9048C71.9048 0 80 8.09524 80 18.0952V61.9048C80 71.9048 71.9048 80 61.9048 80H18.0952C8.09524 80 0 71.9048 0 61.9048V18.0952C0 8.09524 8.09524 0 18.0952 0Z",
    fill: "#00D632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0865 29.7499C53.7115 30.3749 54.749 30.3749 55.3365 29.7499L58.4615 26.4999C59.124 25.8749 59.0865 24.7499 58.3865 24.0749C55.9308 21.936 53.0759 20.3046 49.9865 19.2749L50.974 14.5249C51.1865 13.4874 50.4115 12.5124 49.374 12.5124H43.324C42.9458 12.5165 42.5805 12.6503 42.2893 12.8915C41.998 13.1327 41.7984 13.4667 41.724 13.8374L40.849 18.0624C32.799 18.4749 25.974 22.5624 25.974 30.9374C25.974 38.1874 31.6115 41.2999 37.574 43.4374C43.2115 45.5874 46.199 46.3874 46.199 49.4124C46.199 52.5249 43.224 54.3499 38.824 54.3499C34.824 54.3499 30.624 53.0124 27.374 49.7499C27.223 49.5987 27.0438 49.4788 26.8464 49.397C26.6491 49.3151 26.4376 49.273 26.224 49.273C26.0103 49.273 25.7988 49.3151 25.6015 49.397C25.4042 49.4788 25.2249 49.5987 25.074 49.7499L21.699 53.1249C21.3814 53.4436 21.2031 53.8751 21.2031 54.3249C21.2031 54.7748 21.3814 55.2063 21.699 55.5249C24.324 58.1124 27.649 59.9874 31.439 61.0249L30.514 65.4874C30.3015 66.5249 31.064 67.4874 32.1015 67.4999L38.164 67.5499C38.5464 67.5516 38.9176 67.4204 39.214 67.1787C39.5104 66.937 39.7136 66.5999 39.789 66.2249L40.664 61.9874C50.349 61.3374 56.249 55.9999 56.249 48.2124C56.249 41.0374 50.374 38.0124 43.249 35.5499C39.174 34.0374 35.649 32.9999 35.649 29.8874C35.649 26.8624 38.9365 25.6624 42.2365 25.6624C46.4365 25.6624 50.474 27.3999 53.1115 29.7749L53.0865 29.7499Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: -1,
    width: 80,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.51640fee341f0f2b88c43760d88157c4.svg";
export { ForwardRef as ReactComponent };